// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_FechamentoDiarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Query de GET /caixa/fechamento-diario.
 *
 * `data` (YYYY-MM-DD) é opcional: sem ela vale o dia de hoje. `franquia_id` é exigido pelo
 * controller, com a mensagem que a tela já conhece — por isso não é validado aqui.
 */
import { registerContract } from './validate'

export interface Caixa_FechamentoDiarioInput {
data?: string
franquia_id?: number
}

registerContract('Caixa_FechamentoDiarioInput', {
  data:        { type: 'string',  required: false },
  franquia_id: { type: 'number',  required: false },
})
